import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  color: #000;\n  font-family: Lora;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n\n  width: max-content;\n  align-content: center;\n  align-items: center;\n\n  .select--wrapper {\n    display: flex;\n\n    select {\n      appearance: none;\n      border-radius: 0;\n      border: 0;\n      padding: 0.3em 1em 0.25em 0.25em;\n      margin-left: 0.25rem;\n\n      font-family: Lora;\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n\n      color: #1871bd;\n      text-align: center;\n      text-decoration-line: underline;\n      text-decoration-style: solid;\n      text-decoration-skip-ink: auto;\n      text-decoration-thickness: auto;\n      text-underline-offset: auto;\n      text-underline-position: from-font;\n\n      background-image: url('data:image/svg+xml, %3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M20.0306%209.53062L12.5306%2017.0306C12.4609%2017.1003%2012.3782%2017.1557%2012.2871%2017.1934C12.1961%2017.2312%2012.0985%2017.2506%2011.9999%2017.2506C11.9014%2017.2506%2011.8038%2017.2312%2011.7127%2017.1934C11.6217%2017.1557%2011.539%2017.1003%2011.4693%2017.0306L3.9693%209.53062C3.82857%209.38988%203.74951%209.19901%203.74951%208.99999C3.74951%208.80097%203.82857%208.61009%203.9693%208.46936C4.11003%208.32863%204.30091%208.24957%204.49993%208.24957C4.69895%208.24957%204.88982%208.32863%205.03055%208.46936L11.9999%2015.4397L18.9693%208.46936C19.039%208.39968%2019.1217%208.34441%2019.2128%208.30669C19.3038%208.26898%2019.4014%208.24957%2019.4999%208.24957C19.5985%208.24957%2019.6961%208.26898%2019.7871%208.30669C19.8781%208.34441%2019.9609%208.39968%2020.0306%208.46936C20.1002%208.53905%2020.1555%208.62177%2020.1932%208.71282C20.2309%208.80386%2020.2503%208.90144%2020.2503%208.99999C20.2503%209.09854%2020.2309%209.19612%2020.1932%209.28716C20.1555%209.37821%2020.1002%209.46093%2020.0306%209.53062Z%22%20fill%3D%22%231871BD%22%2F%3E%0A%3C%2Fsvg%3E');\n\n      background-repeat: no-repeat;\n      padding-right: calc(0.5em + 0.75rem);\n      background-position: center right;\n      background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import hash from 'string-hash';
export default function RegistryCCSelectDropDown(props) {
  var label = props.label,
      id = props.id,
      options = props.options;
  var key = id || "select-".concat(hash(props.label));

  var opts = function opts(options) {
    return options.map(function (option) {
      return jsx("option", {
        value: option.value,
        key: "".concat(id, "_").concat(option.label)
      }, option.label);
    });
  };

  return jsx("span", {
    css: CS_SELECT,
    className: "labeled-select",
    key: "select--key-".concat(hash(props.label))
  }, jsx("label", {
    htmlFor: key
  }, label, ":"), jsx("div", {
    className: "select--wrapper"
  }, jsx("select", {
    id: key,
    name: props.name,
    value: props.value,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus
  }, opts(options))));
}
var CS_SELECT = css(_templateObject());